import type { ReactNode } from "react"
import { Fragment } from "react"

import isNull from "lodash-es/isNull"
import { DateTime } from "luxon"

import type { TTFunction } from "$/i18n/i18n"

import {
    ESpecialChar,
    ETypographyColor,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    SpecialChars,
    Typography
} from "@/3514/components"

function renderSessionDate(params: {
    isMain: boolean
    isSelected: boolean
    startDate: string
    endDate: string
    t: TTFunction
}): ReactNode {
    const start: DateTime | null =
        isNull(params.startDate) || !DateTime.fromISO(params.startDate).isValid
            ? null
            : DateTime.fromISO(params.startDate).toLocal()
    const end: DateTime | null =
        isNull(params.startDate) || !DateTime.fromISO(params.startDate).isValid
            ? null
            : DateTime.fromISO(params.endDate).toLocal()

    const datePart: string = isNull(start) ? params.t("common.tbd") : start.toFormat("EEE, LLL d")
    const startTime: string = isNull(start) ? null : start.toFormat("h:mma").toLowerCase()
    const endTime: string = isNull(end) ? null : end.toFormat("h:mma").toLowerCase()

    return params.isMain ? (
        <Typography
            size={ETypographySize.Small}
            className="inline-flex"
            text={
                <Fragment>
                    <Typography
                        text={datePart}
                        size={ETypographySize.Small}
                        tag={ETypographyTag.Span}
                        weight={ETypographyWeight.Bold}
                        color={ETypographyColor.Black}
                    />
                    <Fragment>
                        {isNull(startTime) || isNull(endTime) ? null : (
                            <Fragment>
                                {SpecialChars[ESpecialChar.EmptySpace]}
                                {SpecialChars[ESpecialChar.CommercialAt]}
                                {SpecialChars[ESpecialChar.EmptySpace]}
                                <Typography
                                    text={`${startTime} - ${endTime}`}
                                    size={ETypographySize.Small}
                                    tag={ETypographyTag.Span}
                                />
                            </Fragment>
                        )}
                    </Fragment>
                </Fragment>
            }
        />
    ) : (
        <Typography
            {...(isNull(startTime) || isNull(endTime)
                ? { text: datePart }
                : { text: `${datePart}, ${startTime} - ${endTime}` })}
            size={ETypographySize.Small}
            color={params.isSelected ? ETypographyColor.Dark : ETypographyColor.Black}
        />
    )
}

const utils = { renderSessionDate }

export { utils as participantHoldUtils }
